export enum ErrorCategory {
  DATABASE = 'database',
  NETWORK = 'network',
  PERMISSION = 'permission',
  VALIDATION = 'validation',
  AUTHENTICATION = 'authentication',
  NOT_FOUND = 'not_found',
  RATE_LIMIT = 'rate_limit',
  UNKNOWN = 'unknown'
}

export interface ClassifiedError {
  category: ErrorCategory;
  message: string;
  userMessage: string;
  originalError: Error;
  retryable: boolean;
  code?: string;
  field?: string;
}

export interface RetryConfig {
  maxAttempts: number;
  baseDelay: number;
  timeout?: number;
}

export const DEFAULT_RETRY_CONFIG: Record<ErrorCategory, RetryConfig> = {
  [ErrorCategory.NETWORK]: { maxAttempts: 3, baseDelay: 1000, timeout: 10000 },
  [ErrorCategory.DATABASE]: { maxAttempts: 2, baseDelay: 1000 },
  [ErrorCategory.RATE_LIMIT]: { maxAttempts: 3, baseDelay: 2000 },
  [ErrorCategory.PERMISSION]: { maxAttempts: 1, baseDelay: 0 },
  [ErrorCategory.VALIDATION]: { maxAttempts: 1, baseDelay: 0 },
  [ErrorCategory.AUTHENTICATION]: { maxAttempts: 1, baseDelay: 0 },
  [ErrorCategory.NOT_FOUND]: { maxAttempts: 1, baseDelay: 0 },
  [ErrorCategory.UNKNOWN]: { maxAttempts: 1, baseDelay: 0 }
};
